module.exports = __webpack_public_path__ + "static/media/home.2b5a4a85.jpg";